<template>
    <metainfo>
        <template v-slot:title="{ content }">
            {{ content ? `${content} | BusinessClassTickets` : 'BusinessClassTickets - Business Class Flights' }}
        </template>
    </metainfo>

    <burgher-menu />
    <modal-status />
    <quote-loader :loading="loading" :appWidth="appWidth" />
    <router-view />
    <footer-component />
    <!-- <coupon-form ref="couponForm" /> -->
    <CookieConsent />
</template>

<script>
// Components
import FooterComponent from './components/Footer/FooterComponent.vue'
import BurgherMenu from './components/BurgherMenu.vue'
import ModalStatus from './common/ModalStatus.vue'
import QuoteLoader from '@/common/QuoteLoader.vue'

// import CouponForm from './components/PopUp/CouponForm.vue'

// Vuex
import { mapState } from 'vuex'
import CookieConsent from './common/UI/CookieConsent.vue'

export default {
    name: 'App',
    components: {
        FooterComponent,
        BurgherMenu,
        ModalStatus,
        QuoteLoader,
        CookieConsent,
    },
    computed: {
        ...mapState({
            appWidth: (state) => state.app.appWidth,
            loading: (state) => state.app.quoteLoading,
        }),
    },

    methods: {
        onResize() {
            this.$store.commit('changeAppWidth', window.innerWidth)
        },
        // showCouponForm() {
        //     this.$refs.couponForm.openModal()
        // },
    },
    beforeCreate() {
        this.$store.dispatch('getSettings')
    },
    created() {
        this.onResize()
        window.addEventListener('resize', this.onResize)
        // setTimeout(() => {
        //     this.showCouponForm()
        // }, 5000)
    },
    unmounted() {
        window.removeEventListener('resize', this.onResize)
    },
    watch: {
        appWidth(value) {
            if (value > 1200) {
                this.$store.commit('displayBurgherMenu', false)
            }
        },
    },
}
</script>

<style lang="scss" src="@/styles/general.scss"></style>
